export { default } from '@mui/material/ListItemText';
